import { cn } from '@undp/design-system-react/cn';
import { P } from '@undp/design-system-react/Typography';
import React from 'react';

interface Props {
  text: string | React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}

export function FootNote(props: Props) {
  const { text, style = {}, className } = props;
  if (typeof text === 'string') {
    if (text.trim() === '') return null;
    return (
      <P
        size='sm'
        marginBottom='none'
        className={cn('text-content-secondary', className)}
        aria-label='Graph footnote'
        style={style}
      >
        {text}
      </P>
    );
  }
  if (React.isValidElement(text))
    return (
      <div className={className} style={style}>
        {text}
      </div>
    );
  console.error('FootNote: Invalid text type. Expected string or React element.');
  return null;
}
